<xena-popover [open]="open" [arrow]="true" [distance]="-2" *ngIf="!!releaseNote">
  <div slot="header" [innerHTML]="releaseNote.title"></div>
  <div slot="trigger">
    <xena-icon-button name="fas-rss"></xena-icon-button>
  </div>
  <span [innerHTML]="releaseNote.summary"></span><br/><br/>
  <a [href]="releaseNote.url" target="_blank" i18n="@@userNotification_readMore">Read more</a>
</xena-popover>
